module.exports = __webpack_public_path__ + "img/img_3.8e47c805.png";